import { Box, HStack, Select, Text } from "@chakra-ui/react";

export type DateRangePreset = "all" | "month" | "3months" | "year";
export type StatusValue = "outstanding" | "paid" | "all";

export type FiltersValue = {
  type: "" | "appointment" | "membership" | "package" | "fee";
  range: DateRangePreset;
  status: StatusValue;
};

export function rangeToTimestamps(range: DateRangePreset): {
  from: number | null;
  to: number | null;
} {
  if (range === "all") return { from: null, to: null };
  const now = new Date();
  const to = now.getTime();
  const from = new Date(now);
  if (range === "month") from.setMonth(from.getMonth() - 1);
  if (range === "3months") from.setMonth(from.getMonth() - 3);
  if (range === "year") from.setFullYear(from.getFullYear() - 1);
  return { from: from.getTime(), to };
}

type Props = {
  value: FiltersValue;
  onChange: (next: FiltersValue) => void;
};

const FilterField = ({
  label,
  children,
}: {
  label: string;
  children: React.ReactNode;
}) => (
  <Box>
    <Text
      fontSize="11px"
      color="#6b7280"
      mb={1}
      textTransform="uppercase"
      letterSpacing="0.04em"
    >
      {label}
    </Text>
    {children}
  </Box>
);

const selectStyles = {
  size: "sm" as const,
  borderColor: "#e6e6e6",
  borderRadius: "8px",
  bg: "white",
  minW: "140px",
};

export const Filters = ({ value, onChange }: Props) => {
  return (
    <HStack spacing={3} mb={3} flexWrap="wrap" align="flex-end">
      <FilterField label="Status">
        <Select
          {...selectStyles}
          value={value.status}
          onChange={(e) =>
            onChange({ ...value, status: e.target.value as StatusValue })
          }
        >
          <option value="outstanding">Outstanding & pending</option>
          <option value="paid">Paid</option>
          <option value="all">All</option>
        </Select>
      </FilterField>
      <FilterField label="Type">
        <Select
          {...selectStyles}
          value={value.type}
          onChange={(e) =>
            onChange({ ...value, type: e.target.value as FiltersValue["type"] })
          }
        >
          <option value="">All types</option>
          <option value="appointment">Appointments</option>
          <option value="membership">Memberships</option>
          <option value="package">Packages</option>
          <option value="fee">Fees</option>
        </Select>
      </FilterField>
      <FilterField label="Date">
        <Select
          {...selectStyles}
          value={value.range}
          onChange={(e) =>
            onChange({ ...value, range: e.target.value as DateRangePreset })
          }
        >
          <option value="all">All time</option>
          <option value="month">Last month</option>
          <option value="3months">Last 3 months</option>
          <option value="year">Last year</option>
        </Select>
      </FilterField>
    </HStack>
  );
};
